export const {
  event,
  event: { delegate, stop, undelegate, whichTransitionEndEvent },
} = window.o_util;
